import React from 'react'

import './Work.css'
import p1 from '../../img/p1.jpg'
import p2 from '../../img/p2.jpg'
import p3 from '../../img/p3.jpg'

function Work() {
    return (
        <>
           
            <div id="work">

                <div className="heading-work">
                    <h1>Work Space</h1>
                </div>
                <div className="quotecontainer">
                    <p>"Design is not just what it looks like and feels like. Design is how it works"</p>
                    <br />
                    <h6>~ Steve Jobs</h6>
                </div>

                <div className="my-project">
                    <h1>My project</h1>

                    <div className="row" >
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                    <img src={p1} alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                <img src={p2} alt="img"/>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                    <img src={p3} alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                <img src={p1} alt="img"/>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                    <img src={p2} alt="img"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-body">
                                <img src={p3} alt="img"/>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>


            </div>
        </>
    )
}

export default Work
